import type { ReactNode } from 'react'

/** A user-tab list that is closed until the viewer chooses to reveal it. */
export function CollapsibleSection({
  title,
  count,
  children,
}: {
  title: string
  count: string | number
  children: ReactNode
}) {
  return (
    <details className="collapsible-section">
      <summary className="section-title">
        <span className="collapsible-section__closed">Show</span>
        <span className="collapsible-section__open">Hide</span> {title} ({count})
      </summary>
      {children}
    </details>
  )
}
